import { ArrowUpRight, BookOpen, Images } from "lucide-react";
import { EncabezadoSeccion, Reveal, Marquee } from "../../shared/motion";

export function EnlacesSeccion({ datos, seccion }) {
  const enlaces = datos.enlaces || [];
  if (enlaces.length === 0) return null;

  return (
    <section className="bt-seccion" aria-label={seccion.titulo}>
      <div className="bt-seccion-interior">
        <EncabezadoSeccion p="bt" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="bt-titulo-enlaces" />
        <Reveal>
          <div className="bt-enlaces">
            {enlaces.map((enlace, i) => (
              <a
                key={i}
                className="bt-boton"
                href={enlace.url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`bt-enlace-adicional-${i}`}
              >
                {enlace.texto}
                <ArrowUpRight strokeWidth={1.5} />
              </a>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function AccesosSeccion({ datos, seccion, acciones }) {
  const accesos = datos.accesos || {};
  const items = [
    accesos.libroFirmas && {
      icono: BookOpen,
      datos: accesos.libroFirmas,
      alHacer: acciones?.onAbrirLibroFirmas,
      testid: "bt-boton-libro-firmas",
    },
    accesos.album && {
      icono: Images,
      datos: accesos.album,
      alHacer: acciones?.onAbrirAlbumColaborativo,
      testid: "bt-boton-album",
    },
  ].filter(Boolean);
  if (items.length === 0) return null;

  return (
    <section className="bt-seccion" aria-label={seccion.titulo}>
      <div className="bt-seccion-interior">
        <EncabezadoSeccion p="bt" etiqueta={seccion.etiqueta} titulo={seccion.titulo} centro testid="bt-titulo-accesos" />
        <Reveal>
          <div className="bt-accesos">
            {items.map((item, i) => (
              <button key={i} type="button" className="bt-acceso" onClick={() => item.alHacer?.()} data-testid={item.testid}>
                <item.icono strokeWidth={1.5} />
                <span>
                  <span className="bt-acceso-titulo">{item.datos.titulo}</span>
                  <span className="bt-acceso-texto" style={{ display: "block" }}>
                    {item.datos.texto}
                  </span>
                </span>
              </button>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}

export function CierreSeccion({ datos }) {
  const { protagonista, evento, legal } = datos;
  const nombre = protagonista?.nombre || "";

  return (
    <>
      <Marquee
        p="bt"
        textos={[`${protagonista?.fraseIntroductoria || "Bautismo"} · ${nombre}`, evento.fechaCorta, evento.ciudad]}
      />
      <section className="bt-seccion bt-cierre" data-testid="bt-cierre">
        <div className="bt-seccion-interior">
          <Reveal>
            <p className="bt-cierre-mensaje">{protagonista?.mensajeCierre}</p>
            <p className="bt-cierre-nombres bt-cierre-caligrafia">{nombre}</p>
            <div className="bt-cierre-legal">
              <span>{legal?.marca}</span>
              {legal?.urlPrivacidad && (
                <a href={legal.urlPrivacidad} target="_blank" rel="noopener noreferrer" data-testid="bt-enlace-privacidad">
                  {legal.textoPrivacidad || "Privacidad"}
                </a>
              )}
              {legal?.urlCondiciones && (
                <a href={legal.urlCondiciones} target="_blank" rel="noopener noreferrer" data-testid="bt-enlace-condiciones">
                  {legal.textoCondiciones || "Condiciones"}
                </a>
              )}
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
